// 분할 모드(HTML 소스 textarea + 비주얼 캔버스) 양방향 동기화의 순수 규칙.
// MailDocCanvas.vue(emit 디바운스)와 HtmlSplitEditor.vue(source guard)가 쓰고,
// node:test 로 경합 시나리오를 검증한다. CommonJS(mailDoc.js 와 동일 관례).

const realTimers = {
    set: (fn, ms) => setTimeout(fn, ms),
    clear: (id) => clearTimeout(id),
}

// 디바운스 emit. flush()/cancel() 은 대기 중인 타이머를 반드시 취소한다 — blur 로 즉시
// emit 한 뒤 남은 타이머가 이전 HTML 을 재방출해 사용자의 소스 편집을 덮어쓰는 경합 방지.
function createDebouncedEmit(fn, delayMs, timers = realTimers) {
    let timer = null
    const cancel = () => {
        if (timer != null) timers.clear(timer)
        timer = null
    }
    return {
        schedule() {
            cancel()
            timer = timers.set(() => { timer = null; fn() }, delayMs)
        },
        // 지금 즉시 emit 하고 대기 타이머는 버린다.
        flush() {
            cancel()
            fn()
        },
        cancel,
        pending: () => timer != null,
    }
}

// source guard — textarea 입력 이후 캔버스가 재마운트되기 전까지 캔버스의 emit 은 stale.
// (캔버스는 write-once 라 소스 편집을 자기 문서에 반영하지 못한 채 이전 HTML 을 들고 있다.)
function createSourceGuard() {
    let sourceRevision = 0
    let canvasRevision = 0
    return {
        // textarea 입력.
        bumpSource() {
            sourceRevision += 1
            return sourceRevision
        },
        // 캔버스 (재)마운트 — 현재 소스 revision 을 캔버스 것으로 채택.
        syncCanvas() {
            canvasRevision = sourceRevision
        },
        // 캔버스 emit 을 부모로 올려도 되는가(마운트 이후 소스 편집이 없었는가).
        canvasIsCurrent() {
            return canvasRevision === sourceRevision
        },
    }
}

module.exports = { createDebouncedEmit, createSourceGuard }
